module.exports = __webpack_public_path__ + "static/media/b_icon_darkmode.a46b9016.svg";